import React from 'react';
import qs from 'qs';

import { FacebookIcon } from '@reverbdotcom/cadence/icons/react';
import { RCTextWithIcon, RCButton } from '@reverbdotcom/cadence/components';

import CsrfForm from '../csrf_form';
import { FACEBOOK_AUTH_PATH } from '../url_helpers';
import { titleText, Variant } from './thirdPartyAuth';
import { GOOGLE_RECAPTCHA_TOKEN_PARAM } from '../constants';

interface Props {
  redirectTo: string;
  variant: Variant;
  handleSubmit: (e, input) => void;
}

const formId = 'facebook-signup-signin';

export default function FacebookSigninButton({ redirectTo, variant, handleSubmit }: Props) {
  const query = qs.stringify({ redirect_to: redirectTo });
  const title = titleText({ provider: 'facebook', variant });
  const googleRecaptchaTokenInput = React.useRef();
  const onSubmit = (e) => {
    if (handleSubmit) {
      handleSubmit(e, googleRecaptchaTokenInput);
    }
  };

  return (
    <CsrfForm
      id={formId}
      method="post"
      action={`${FACEBOOK_AUTH_PATH}?${query}`}
      onSubmit={(event) => { onSubmit(event); }}
    >
      <div className="signup-signin__form__facebook__button">
        <RCButton
          isSubmit
          form={formId}
          variant="primary"
          fullWidth
        >
          <RCTextWithIcon
            svgComponent={FacebookIcon}
            placement="left"
            size="large"
          >
            {title}
          </RCTextWithIcon>
        </RCButton>
      </div>
      <input type="hidden" name={GOOGLE_RECAPTCHA_TOKEN_PARAM} ref={googleRecaptchaTokenInput} />
    </CsrfForm>
  );
}
